import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
    Stack,
    Chip,
    Divider,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import InfoIcon from "@mui/icons-material/Info";
import PeopleIcon from "@mui/icons-material/People";
import { useNavigate } from "react-router-dom";

const EventPopup = ({ open, onClose, event }) => {
    const navigate = useNavigate();

    if (!event) return null;

    const {
        title,
        name,
        start,
        end,
        meta = {},
    } = event;

    const {
        type,
        status,
        description,
        participants = [],
        creator,
    } = meta;

    const startDate = start ? new Date(start).toLocaleString("pl-PL") : "-";
    const endDate = end ? new Date(end).toLocaleString("pl-PL") : "-";

   const anonymizeEmail = (email) => {
    if (!email || typeof email !== "string") return "";

    const [user, domain] = email.split("@");
    if (!domain) return email;

    const visible = user.slice(0, 2);
    return `${visible}${"*".repeat(Math.max(user.length - 2, 3))}@${domain}`;
    };
    
    return (
        <Dialog open={open && !!event} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 600 }}>
                {title || name || "Szczegóły wydarzenia"}
            </DialogTitle>

            <DialogContent dividers>
                <Stack spacing={2}>
                    <Box>
                        <Typography variant="body2" color="text.secondary">
                            <EventIcon sx={{ fontSize: 18, mr: 1, verticalAlign: "middle" }} />
                            {startDate} — {endDate}
                        </Typography>
                    </Box>

                    <Stack direction="row" spacing={1}>
                        {type && <Chip label={`Typ: ${type}`} color="primary" size="small" />}
                        {/* {status && (
                            <Chip
                                label={`Status: ${status}`}
                                color={status === "upcoming" ? "success" : "default"}
                                size="small"
                            />
                        )} */}
                    </Stack>

                    <Divider />

                    {description && (
                        <Box>
                            <Typography
                                variant="subtitle2"
                                sx={{ display: "flex", alignItems: "center", gap: 1 }}
                            >
                                <InfoIcon fontSize="small" />
                                Opis
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {description}
                            </Typography>
                        </Box>
                    )}

                    {participants.length > 0 && (
                        <Box>
                            <Typography
                                variant="subtitle2"
                                sx={{ display: "flex", alignItems: "center", gap: 1 }}
                            >
                                <PeopleIcon fontSize="small" />
                                Uczestnicy
                            </Typography>

                            <Stack spacing={0.5} sx={{ mt: 1 }}>
                                {participants.map((p) => (
                                    <Typography key={p.id} variant="body2">
                                        {/* • {p.name} */}
                                        • {anonymizeEmail(p.name)}
                                    </Typography>
                                ))}
                            </Stack>
                        </Box>
                    )}

                    {creator && (
                        <Typography variant="caption" color="text.secondary">
                            Utworzone przez: {creator.name}
                        </Typography>
                    )}
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    Zamknij
                </Button>

                <Button
                    variant="contained"
                    onClick={() => navigate("/vr/callendar")}
                >
                    Przejdź do kalendarza
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EventPopup;